////////////////////////////
//CURRENT BOOKING
////////////////////////////
export const SET_BOOKING_DETAILS = "SET_BOOKING_DETAILS";
export const BOOKING_DETAILS_LOADING = "BOOKING_DETAILS_LOADING";


////////////////////////////
//UTILS
////////////////////////////
export const SET_TOGGLE_COLLAPSE = "SET_TOGGLE_COLLAPSE";



////////////////////////////
//DEPARTURES
////////////////////////////
export const SET_DEPARTURES = "SET_DEPARTURES";